<template>
  <el-scrollbar style="height: 100%">
    <div class="page-system-log" :style="{ height: pageHeight + 'px' }">
      <el-card class="card" v-for="(item, index) in list" :key="index">
        <div class="location">D楼5层-D515-1</div>
        <div class="status">
          非监测时段
          <div class="badge">30</div>
        </div>
        <div class="monitor-time">
          <div>监测时间段12:50-14:15</div>
          <div>
            <el-button type="text" @click="viewInfo(item)"
              >查看<span class="el-icon-d-arrow-right"></span
            ></el-button>
          </div>
        </div>
      </el-card>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
    </div>
  </el-scrollbar>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      pageHeight: 0,
      list: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
    };
  },
  created() {},
  mounted() {
    this.pageHeight = window.innerHeight - 60;

    window.addEventListener("resize", () => {
      this.pageHeight = window.innerHeight - 60;
    });
  },
  computed: {},
  methods: {
    viewInfo(data){
      this.$router.push({
        path: "/real-time",
        query: data,
      })
    }
  },
  watch: {},
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.pageHeight = window.innerHeight - 60;
    });
  },
};
</script>

<style scoped lang='less'>
.page-system-log {
  width: 100%;
  padding-top: 10px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .card {
    min-width: 300px;
    height: 200px;
    margin: 0 10px 10px 0;
    box-sizing: border-box;

    .location {
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }
    .status {
      height: 100px;
      border: 1px solid red;
      box-sizing: border-box;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 0;
      position: relative;

      .badge {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 0;
        right: 0;
        text-align: center;
        line-height: 40px;
        color: #fff;
        border-radius: 100%;
        background: gainsboro;
      }
    }
    .monitor-time {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      div:first-child {
        font-size: 14px;
      }
      div:last-child {
        .el-button {
          font-size: 16px;
          padding: 0;
        }
      }
    }
  }
  i {
    min-width: 300px;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue